import { useMutation } from "@tanstack/react-query";
import fetchData from "../fetcher";
import { LoginTypes, LoginResponse } from "./types";

export const useLogin = () => {
    const { mutateAsync, data, isPending, error, isError } = useMutation({
        mutationKey: ["login"],
        mutationFn: (body: LoginTypes) => fetchData<LoginResponse>("/iam/v4/auth/login", { body, method: "POST" }),
    });

    return { mutateAsync, data, isPending, error, isError };
}